import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const statusApi = createApi({
  reducerPath: "statusApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Statuses"],
  endpoints: (builder) => ({
    // Get all Statuses. Every consumer of this hook expects the full,
    // unpaginated catalog (dropdowns, badges, the admin Status/Transition
    // tables) - the list endpoint defaults to a page size of 20, which
    // silently drops older statuses once the catalog grows past that, so
    // request the endpoint's max page size explicitly.
    getStatuses: builder.query({
      query: () => "/statuses?limit=100",
      transformResponse: (response) => response.data || response,
      providesTags: ["Statuses"],
    }),

    // Get a single Status
    getStatusById: builder.query({
      query: (id) => `/statuses/${id}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, id) => [{ type: "Statuses", id }],
    }),

    // Create a new Status
    createStatus: builder.mutation({
      query: (status) => ({
        url: `/statuses`,
        method: "POST",
        body: status,
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["Statuses"],
    }),

    // Update an existing Status
    updateStatus: builder.mutation({
      query: ({ id, ...status }) => ({
        url: `/statuses/${id}`,
        method: "PUT",
        body: status,
      }),
      invalidatesTags: ["Statuses"],
    }),

    // Delete an existing Status
    deleteStatus: builder.mutation({
      query: (id) => ({
        url: `/statuses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Statuses"],
    }),
  }),
});

export const {
  useGetStatusesQuery,
  useGetStatusByIdQuery,
  useCreateStatusMutation,
  useUpdateStatusMutation,
  useDeleteStatusMutation,
} = statusApi;
